import { Component, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';

import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { scrollTo } from '@ngui/utils';

import { BudgetService } from '../service/budget.service';
import { CashFlowService } from '../service/cashflow.service';
import { CompanyService } from '../service/company.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { ProjectService } from '../service/project.service';
import { UtilsService } from '../service/utils.service';

@Component({
  selector: 'app-cashflow',
  templateUrl: './cashflow.component.html',
  styleUrls: ['./cashflow.component.css'],
})
export default class CashflowComponent {
  constructor(
    private cashflowservice: CashFlowService,
    private operatingexpensesService: OperatingexpensesService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private budgetService: BudgetService,
    private loanService: LoanService,
    private utils: UtilsService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.companyId = localStorage.getItem('companyId');
    this.projectId = localStorage.getItem('projectId');
    this.showInstructions = false;
    this.print = false;
    this.show = false;
    this.getCompanyData();
    this.getProjectData();
    this.cashflowservice.getCashFlow();
    this.getCashFlow();
    this.getProjectType();
  }

  // DECLARATION FOR FIXED TABLE SCROLLING
  id = 's1';

  hid = 'h1';

  wid = 'w1';

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  @Input() print: boolean;

  @Input() showSummary: boolean;

  @Output() cashFlowEmit: EventEmitter<any> = new EventEmitter();

  @Output() projectEmitCashFlow: EventEmitter<any> = new EventEmitter();

  setTimeOutClear: any;

  // DECLARATION OF ALL VARIABLES
  companyId = '';

  companyLogoUrl = '';

  projectId = '';

  // DECLARATION OF OBJECT TO pass data to table component to SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCREN
  parentObject: any = {
    labels: [],
    months: [],
    tds: [],
    tables: new Array(1),
    minimumValue: 0,
  };

  year = 1;

  show: boolean;

  cashFlowData = {};

  projectData = {};

  projectName = '';

  start_up_month: number;

  licensedBeds: number;

  averageNightShiftHours: number;

  maintenanceReserve: number;

  maintenanceReserveContribution: number;

  operatingCapital: number;

  operatingCapitalInt: number;

  foodCost: number;

  foodCostInt: number;

  averageHourlyWage: number;

  averageHourlyWageInt: number;

  vacancyFactor: number;

  vacancyFactorInt: number;

  inflationRate: number;

  selectionType: string;

  occupiedTotal = 0;

  bedRate: number;

  bedRateInt: number;

  projectType: any;

  /** *************For 120 Months ************** */
  occupiedBedsArray = [];

  netOperatingExpensesArray = [];

  grossOperatingIncomeArray = [];

  grossOperatingIncomeTenYearsArray = [];

  opexTenYearsArray = [];

  profitLossArray = [];

  operatingArray = [];

  maintenanceArray = [];

  netCashFlowArray = [];

  totalOpex = [];

  totalOpexArray = [];

  cashInfusionArray = [];

  cashDistributionArray = [];

  debtServiceArray = [];

  /** ************* For Graph************ */
  GOIQuaterlyArray = [];

  OEQuaterlyArray = [];

  NOIQuaterlyArray = [];

  DSQuaterlyArray = [];

  PLQuaterlyArray = [];

  CIQuaterlyArray = [];

  CDQuaterlyArray = [];

  NCFQuaterlyArray = [];

  AOCQuaterlyArray = [];

  AMQuaterlyArray = [];

  /** ************ For Ten Year Totals ************ */
  GOITenArray = [];

  OETenArray = [];

  NOITenArray = [];

  DSTenArray = [];

  PLTenArray = [];

  netProfitPercentages = [];

  annualDebtServiceMultiples = [];

  CITenArray = [];

  CDTenArray = [];

  NCFTenArray = [];

  AOCTenArray = [];

  AMTenArray = [];

  /** ************ For Cumulative Year Totals ********** */
  GOIComArray = [];

  OEComArray = [];

  NOIComArray = [];

  DSComArray = [];

  PLComArray = [];

  debtServiceMultiplesCumulative = [];

  netProfitPercentagesCumulative = [];

  CIComArray = [];

  CDComArray = [];

  NCFComArray = [];

  AOCComArray = [];

  AMComArray = [];

  showInstructions: boolean;

  // declaration of graph variables
  selectLabel = ['GOI', 'NOI'];

  public lineChartLegend = true;

  public lineChartType = 'line';

  projectOverallData = [];

  public lineChartData: any[] = [
    {
      data: this.cashflowservice.GOIQuaterlyArray,
      label: 'GOI',
      fill: false,
      lineTension: 0,
      borderWidth: 3,
    },
    {
      data: this.cashflowservice.NOIQuaterlyArray,
      label: 'NOI',
      fill: false,
      lineTension: 0,
      borderWidth: 3,
    },
  ];

  public lineChartColors: any[] = [
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
    {
      backgroundColor: '#54b569',
      borderColor: '#54b569',
      pointBackgroundColor: '#54b569',
      pointBorderColor: '#54b569',
      pointHoverBackgroundColor: '#54b569',
      pointHoverBorderColor: '#54b569 ',
    },
  ];

  public lineChartLabels: any[] = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
  ];

  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label(tooltipItem) {
          const val = Math.round(tooltipItem.yLabel);
          return `$ ${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
          // return '$ '+tooltipItem.yLabel;
        },
        title(tooltipItem) {
          return `${tooltipItem[0].xLabel} Quarter`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            // color: 'rgba(0,0,0,0)'
          },
          ticks: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontColor: 'black',
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            // borderDash: [4, 8],
          },
          ticks: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontColor: 'black',
            callback(value) {
              const val = Math.round(value * 10) / 10;
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
      ],
    },
  };

  scrollTo(selector, parentSelector, horizontal) {
    scrollTo(
      selector, // scroll to this
      parentSelector, // scroll within (null if window scrolling)
      horizontal, // is it horizontal scrolling
      0 // distance from top or left
    );
    this.hid = selector.split('#').join('');
  }

  // save data of cash flow into db for every time when come to this page
  getCashFlow() {
    const data = {
      project_id: this.projectId,
      year: this.year,
      inflation_rate: this.inflationRate,
      start_up_month: this.start_up_month,
    };

    this.projectService.calculateTenYears(data).subscribe(() => {
      const cashFlowData = { projectId: this.projectId };
      this.operatingexpensesService.updateCashFlow(cashFlowData).subscribe(() => {
        this.updateRemaing();
      });
    });
  }

  // get data of 120 months from db and set into arrays for ten year, 120 months and for graph also for cash flow page only
  updateRemaing() {
    const data = { projectId: this.projectId };
    this.projectService.getOccupiedBeds(data).subscribe((res) => {
      // Intiliaztion of all variables
      this.occupiedBedsArray = [];
      this.netOperatingExpensesArray = [];
      this.grossOperatingIncomeArray = [];
      this.profitLossArray = [];
      this.operatingArray = [];
      this.maintenanceArray = [];
      this.netCashFlowArray = [];
      this.totalOpexArray = [];
      this.cashInfusionArray = [];
      this.cashDistributionArray = [];
      this.debtServiceArray = [];

      this.GOIComArray = [];
      this.OEComArray = [];
      this.NOIComArray = [];
      this.DSComArray = [];
      this.PLComArray = [];
      this.debtServiceMultiplesCumulative = [];
      this.netProfitPercentagesCumulative = [];
      this.CIComArray = [];
      this.CDComArray = [];
      this.NCFComArray = [];
      this.AOCComArray = [];
      this.AMComArray = [];

      this.GOITenArray = [];
      this.OETenArray = [];
      this.NOITenArray = [];
      this.DSTenArray = [];
      this.PLTenArray = [];
      this.annualDebtServiceMultiples = [];
      this.netProfitPercentages = [];
      this.CITenArray = [];
      this.CDTenArray = [];
      this.NCFTenArray = [];
      this.AOCTenArray = [];
      this.AMTenArray = [];

      this.GOIQuaterlyArray = [];
      this.OEQuaterlyArray = [];
      this.NOIQuaterlyArray = [];
      this.DSQuaterlyArray = [];
      this.PLQuaterlyArray = [];
      this.CIQuaterlyArray = [];
      this.CDQuaterlyArray = [];
      this.NCFQuaterlyArray = [];
      this.AOCQuaterlyArray = [];
      this.AMQuaterlyArray = [];

      this.occupiedBedsArray = res.data;

      // Calculate GOI for monthly and yearly
      let i = 0;
      let iquater = 0;
      let iten = 0;
      let additionGOI = 0;
      let additionthreeGOI = 0;
      let additionfiveGOI = 0;
      let additionsevenGOI = 0;
      let additiontenGOI = 0;

      this.occupiedBedsArray.forEach((element) => {
        this.grossOperatingIncomeArray[i] = element.goi;

        additionGOI += element.goi;
        if ((i + 1) % 3 === 0) {
          this.GOIQuaterlyArray[iquater] = additionGOI;
          additionGOI = 0;
          iquater += 1;
        }
        additiontenGOI += element.goi;
        if ((i + 1) % 12 === 0) {
          this.GOITenArray[iten] = additiontenGOI;
          additiontenGOI = 0;
          iten += 1;
        }
        i += 1;
      });
      // Cumulative Calculations
      additionthreeGOI = this.GOITenArray[0] + this.GOITenArray[1] + this.GOITenArray[2];
      additionfiveGOI = additionthreeGOI + this.GOITenArray[3] + this.GOITenArray[4];
      additionsevenGOI = additionfiveGOI + this.GOITenArray[5] + this.GOITenArray[6];
      additiontenGOI =
        additionsevenGOI + this.GOITenArray[7] + this.GOITenArray[8] + this.GOITenArray[9];
      this.GOIComArray.push(additionthreeGOI, additionfiveGOI, additionsevenGOI, additiontenGOI);

      // Calculate Less:Operating Income for monthly and yearly
      let o = 0;
      let oten = 0;
      let oquater = 0;
      let additionOE = 0;
      let additionthreeOE = 0;
      let additionfiveOE = 0;
      let additionsevenOE = 0;
      let additiontenOE = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.totalOpexArray[o] = -element.total_opex;

        additionOE += element.total_opex;
        if ((o + 1) % 3 === 0) {
          this.OEQuaterlyArray[oquater] = additionOE;
          additionOE = 0;
          oquater += 1;
        }
        additiontenOE += -element.total_opex;
        if ((o + 1) % 12 === 0) {
          this.OETenArray[oten] = additiontenOE;
          additiontenOE = 0;
          oten += 1;
        }
        o += 1;
      });
      // Cumulative Calculations
      additionthreeOE = this.OETenArray[0] + this.OETenArray[1] + this.OETenArray[2];
      additionfiveOE = additionthreeOE + this.OETenArray[3] + this.OETenArray[4];
      additionsevenOE = additionfiveOE + this.OETenArray[5] + this.OETenArray[6];
      additiontenOE =
        additionsevenOE + this.OETenArray[7] + this.OETenArray[8] + this.OETenArray[9];
      this.OEComArray.push(additionthreeOE, additionfiveOE, additionsevenOE, additiontenOE);

      // Calculate Net Operating Income for monthly and yearly
      let b = 0;
      let bten = 0;
      let bquater = 0;
      let additionNOI = 0;
      let additionthreeNOI = 0;
      let additionfiveNOI = 0;
      let additionsevenNOI = 0;
      let additiontenNOI = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.netOperatingExpensesArray[b] = element.goi + -element.total_opex;

        additionNOI += this.netOperatingExpensesArray[b];
        if ((b + 1) % 3 === 0) {
          this.NOIQuaterlyArray[bquater] = additionNOI;
          additionNOI = 0;
          bquater += 1;
        }
        additiontenNOI += this.netOperatingExpensesArray[b];
        if ((b + 1) % 12 === 0) {
          this.NOITenArray[bten] = additiontenNOI;
          additiontenNOI = 0;
          bten += 1;
        }
        b += 1;
      });
      // Cumulative Calculations
      additionthreeNOI = this.NOITenArray[0] + this.NOITenArray[1] + this.NOITenArray[2];
      additionfiveNOI = additionthreeNOI + this.NOITenArray[3] + this.NOITenArray[4];
      additionsevenNOI = additionfiveNOI + this.NOITenArray[5] + this.NOITenArray[6];
      additiontenNOI =
        additionsevenNOI + this.NOITenArray[7] + this.NOITenArray[8] + this.NOITenArray[9];
      this.NOIComArray.push(additionthreeNOI, additionfiveNOI, additionsevenNOI, additiontenNOI);

      // Calculate Debt Service for monthly and yearly
      let c = 0;
      let cten = 0;
      let cquater = 0;
      let additionDS = 0;
      let additionthreeDS = 0;
      let additionfiveDS = 0;
      let additionsevenDS = 0;
      let additiontenDS = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.debtServiceArray[c] = element.debt;

        additionDS += element.debt;
        if ((c + 1) % 3 === 0) {
          this.DSQuaterlyArray[cquater] = additionDS;
          additionDS = 0;
          cquater += 1;
        }
        additiontenDS += element.debt;
        if ((c + 1) % 12 === 0) {
          this.DSTenArray[cten] = additiontenDS;
          additiontenDS = 0;
          cten += 1;
        }
        c += 1;
      });
      // Cumulative Calculations
      additionthreeDS = this.DSTenArray[0] + this.DSTenArray[1] + this.DSTenArray[2];
      additionfiveDS = additionthreeDS + this.DSTenArray[3] + this.DSTenArray[4];
      additionsevenDS = additionfiveDS + this.DSTenArray[5] + this.DSTenArray[6];
      additiontenDS =
        additionsevenDS + this.DSTenArray[7] + this.DSTenArray[8] + this.DSTenArray[9];
      this.DSComArray.push(additionthreeDS, additionfiveDS, additionsevenDS, additiontenDS);

      //
      // Calculate the debt service coverage as shown on the Financial Reports. It is just
      // the NOI / debt service (assuming debt service is not zero). We need this on an annual basis.
      //
      for (let year = 0; year < this.NOITenArray.length; year += 1) {
        const debtServiceMultiple = this.NOITenArray[year] / this.DSTenArray[year];
        this.annualDebtServiceMultiples.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );
      }
      for (let index = 0; index < 4; index += 1) {
        const debtServiceMultiple = this.NOIComArray[index] / this.DSComArray[index];
        this.debtServiceMultiplesCumulative.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );
      }

      // Calculate CASH INFUSION for monthly and yearly
      let d = 0;
      let dten = 0;
      let dquater = 0;
      let additionCI = 0;
      let additionthreeCI = 0;
      let additionfiveCI = 0;
      let additionsevenCI = 0;
      let additiontenCI = 0;
      this.occupiedBedsArray.forEach((element) => {
        this.cashInfusionArray[d] = element.cash_infusion;

        additionCI += element.cash_infusion;
        if ((d + 1) % 3 === 0) {
          this.CIQuaterlyArray[dquater] = additionCI;
          additionCI = 0;
          dquater += 1;
        }
        additiontenCI += element.cash_infusion;
        if ((d + 1) % 12 === 0) {
          this.CITenArray[dten] = additiontenCI;
          additiontenCI = 0;
          dten += 1;
        }
        d += 1;
      });
      // Cumulative Calculations
      additionthreeCI = this.CITenArray[0] + this.CITenArray[1] + this.CITenArray[2];
      additionfiveCI = additionthreeCI + this.CITenArray[3] + this.CITenArray[4];
      additionsevenCI = additionfiveCI + this.CITenArray[5] + this.CITenArray[6];
      additiontenCI =
        additionsevenCI + this.CITenArray[7] + this.CITenArray[8] + this.CITenArray[9];
      this.CIComArray.push(additionthreeCI, additionfiveCI, additionsevenCI, additiontenCI);

      // Calculate CASH DISTRIBUTION for monthly and yearly
      // let e=0;
      let eten = 0;
      let equater = 0;
      let additionCD = 0;
      let additionthreeCD = 0;
      let additionfiveCD = 0;
      let additionsevenCD = 0;
      let additiontenCD = 0;
      // this.cashDistributionArray[0] = 0;
      for (let e = 0; e < this.occupiedBedsArray.length; e += 1) {
        // this.cashDistributionArray[e+1] = this.occupiedBedsArray[e].cash_distribution;
        // amitcodedhome
        this.cashDistributionArray[e] = this.occupiedBedsArray[e].cash_distribution;

        additionCD += this.cashDistributionArray[e];
        if (e % 3 === 0) {
          this.CDQuaterlyArray[equater] = additionCD;
          additionCD = 0;
          equater += 1;
        }
        additiontenCD += this.cashDistributionArray[e];
        if ((e + 1) % 12 === 0) {
          this.CDTenArray[eten] = additiontenCD;
          additiontenCD = 0;
          eten += 1;
        }
      }

      // Cumulative Calculations
      additionthreeCD = this.CDTenArray[0] + this.CDTenArray[1] + this.CDTenArray[2];
      additionfiveCD = additionthreeCD + this.CDTenArray[3] + this.CDTenArray[4];
      additionsevenCD = additionfiveCD + this.CDTenArray[5] + this.CDTenArray[6];
      additiontenCD =
        additionsevenCD + this.CDTenArray[7] + this.CDTenArray[8] + this.CDTenArray[9];
      this.CDComArray.push(additionthreeCD, additionfiveCD, additionsevenCD, additiontenCD);

      // Calculate PL for monthly and yearly
      let jten = 0;
      let jquater = 0;
      let additionPL = 0;
      let additionthreePL = 0;
      let additionfivePL = 0;
      let additionsevenPL = 0;
      let additiontenPL = 0;
      let additionAOC = 0;
      for (let j = 0; j < 120; j += 1) {
        this.profitLossArray[j] = this.netOperatingExpensesArray[j] + -this.debtServiceArray[j];
        if (j === 0) {
          this.operatingArray[j] =
            +this.netOperatingExpensesArray[j] + -this.debtServiceArray[j] + +this.operatingCapital;
        } else {
          this.operatingArray[j] =
            +this.netOperatingExpensesArray[j] +
            -this.debtServiceArray[j] +
            +this.operatingArray[j - 1];
        }
        additionPL += this.profitLossArray[j];
        additionAOC += this.operatingArray[j];
        if ((j + 1) % 3 === 0) {
          this.PLQuaterlyArray[jquater] = additionPL;
          additionPL = 0;
          this.AOCQuaterlyArray[jquater] = additionAOC;
          additionAOC = 0;
          jquater += 1;
        }

        additiontenPL += this.profitLossArray[j];
        if ((j + 1) % 12 === 0) {
          this.PLTenArray[jten] = additiontenPL;
          this.netProfitPercentages[jten] = this.PLTenArray[jten] / this.GOITenArray[jten];
          additiontenPL = 0;
          this.AOCTenArray[jten] =
            +this.netOperatingExpensesArray[j] +
            -this.debtServiceArray[j] +
            +this.operatingArray[j - 1];
          jten += 1;
        }
      }
      // Cumulative Calculations
      additionthreePL = this.PLTenArray[0] + this.PLTenArray[1] + this.PLTenArray[2];
      additionfivePL = additionthreePL + this.PLTenArray[3] + this.PLTenArray[4];
      additionsevenPL = additionfivePL + this.PLTenArray[5] + this.PLTenArray[6];
      additiontenPL =
        additionsevenPL + this.PLTenArray[7] + this.PLTenArray[8] + this.PLTenArray[9];
      this.PLComArray.push(additionthreePL, additionfivePL, additionsevenPL, additiontenPL);
      this.netProfitPercentagesCumulative.push(
        additionthreePL / additionthreeGOI,
        additionfivePL / additionfiveGOI,
        additionsevenPL / additionsevenGOI,
        additiontenPL / additiontenGOI
      );
      //
      // The "Operating Capital" is essentially a bank account balance, so it isn't actuall "cumulative". These values are
      // points in time, so we show the values from years 3, 5, 7, and 10 in the cumulative table.
      //
      this.AOCComArray.push(
        this.AOCTenArray[2],
        this.AOCTenArray[4],
        this.AOCTenArray[6],
        this.AOCTenArray[9]
      );

      // Calculate NCF for monthly and yearly
      let mten = 0;
      let mquater = 0;
      let additionNCF = 0;
      let additionthreeNCF = 0;
      let additionfiveNCF = 0;
      let additionsevenNCF = 0;
      let additiontenNCF = 0;
      for (let m = 0; m < 120; m += 1) {
        this.netCashFlowArray[m] =
          this.profitLossArray[m] - this.cashDistributionArray[m] + this.cashInfusionArray[m];

        additionNCF += this.netCashFlowArray[m];
        if ((m + 1) % 3 === 0) {
          this.NCFQuaterlyArray[mquater] = additionNCF;
          additionNCF = 0;
          mquater += 1;
        }

        additiontenNCF += this.netCashFlowArray[m];
        if ((m + 1) % 12 === 0) {
          this.NCFTenArray[mten] = additiontenNCF;
          additiontenNCF = 0;
          mten += 1;
        }
      }
      // Cumulative Calculations
      additionthreeNCF = this.NCFTenArray[0] + this.NCFTenArray[1] + this.NCFTenArray[2];
      additionfiveNCF = additionthreeNCF + this.NCFTenArray[3] + this.NCFTenArray[4];
      additionsevenNCF = additionfiveNCF + this.NCFTenArray[5] + this.NCFTenArray[6];
      additiontenNCF =
        additionsevenNCF + this.NCFTenArray[7] + this.NCFTenArray[8] + this.NCFTenArray[9];
      this.NCFComArray.push(additionthreeNCF, additionfiveNCF, additionsevenNCF, additiontenNCF);

      // Calculate MR for monthly and yearly
      let l = 0;
      let lten = 0;
      let lquater = 0;
      let additionAMQ = 0;
      this.grossOperatingIncomeArray.forEach((element) => {
        let calculatedValue =
          +this.maintenanceReserve +
          +Math.round((this.maintenanceReserveContribution / 100) * element) -
          this.occupiedBedsArray[l].repairs_maintenance;
        calculatedValue = Number.isNaN(calculatedValue) ? 0 : calculatedValue;
        if (l === 0) {
          this.maintenanceArray[l] = calculatedValue;
        } else {
          let maintenanceValue =
            +this.maintenanceArray[l - 1] +
            +Math.round((this.maintenanceReserveContribution / 100) * element) -
            this.occupiedBedsArray[l].repairs_maintenance;
          maintenanceValue = Number.isNaN(maintenanceValue) ? 0 : maintenanceValue;
          this.maintenanceArray[l] = maintenanceValue;
        }

        additionAMQ += this.maintenanceArray[l];
        if ((l + 1) % 3 === 0) {
          this.AMQuaterlyArray[lquater] = additionAMQ;
          additionAMQ = 0;
          lquater += 1;
        }

        if ((l + 1) % 12 === 0) {
          this.AMTenArray[lten] = this.maintenanceArray[l];
          lten += 1;
        }
        l += 1;
      });
      // Cumulative Calculations
      //
      // The "Maintenance Reserve" is essentially a bank account balance, so it isn't actuall "cumulative". These values are
      // points in time, so we show the values from years 3, 5, 7, and 10 in the cumulative table.
      //
      this.AMComArray.push(
        this.AMTenArray[2],
        this.AMTenArray[4],
        this.AMTenArray[6],
        this.AMTenArray[9]
      );

      // let this = this;
      this.parentObject = {
        labels: [],
        months: [],
        tds: [],
        tables: new Array(1),
        minimumValue: 0,
      };
      for (let monthNumber = 1; monthNumber <= 120; monthNumber += 1) {
        this.parentObject.months.push(monthNumber);
      }

      this.parentObject.labels.push(
        'Gross Operating Income',
        'Less: Operating Expenses',
        'Net Operating Income',
        'Less: Debt Service',
        'Net Cash Flow',
        'Account 1: Operating Capital',
        'Account 2: Maintenance Reserve',
        'Loan Proceeds',
        'Loan Payoffs'
      );
      this.parentObject.minimumValue = Math.min(...this.operatingArray);
      this.parentObject.tds.push(
        this.grossOperatingIncomeArray,
        this.totalOpexArray,
        this.netOperatingExpensesArray,
        this.debtServiceArray,
        this.profitLossArray,
        this.operatingArray,
        this.maintenanceArray,
        this.cashInfusionArray,
        this.cashDistributionArray
      );
      if (this.print) {
        this.parentObject.tables = new Array(4);
      }
      this.parentObject.print = this.print;
      this.parentObject.start_up_month = this.start_up_month;
      this.cashFlowEmit.emit({ cashFlowEmit: true });
    });
  }

  // TO GET SAVED PROJECT DATA FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectId = localStorage.getItem('projectId');
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.selectionType = projectData.data[0].selection_type;
      this.start_up_month = projectData.data[0].start_up_month;
      this.licensedBeds = projectData.data[0].licensed_beds;

      this.averageHourlyWage = projectData.data[0].average_hourly_wage;
      this.averageHourlyWageInt = projectData.data[0].average_hourly_wage;

      this.inflationRate = projectData.data[0].inflation_rate;

      if (this.selectionType === 'other') {
        this.bedRate = projectData.data[0].bed_rate_other;
        this.bedRateInt = projectData.data[0].bed_rate_other;
        this.show = false;
      } else {
        this.bedRate = projectData.data[0].bed_rate;
        this.bedRateInt = projectData.data[0].bed_rate_other;
        this.show = true;
      }

      this.foodCost = projectData.data[0].food_cost;
      this.foodCostInt = projectData.data[0].food_cost;
      this.vacancyFactor = projectData.data[0].vacancy_factor;
      this.vacancyFactorInt = projectData.data[0].vacancy_factor;

      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInt = projectData.data[0].operating_capital;

      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.maintenanceReserveContribution = projectData.data[0].maintenance_reserve_contribution;

      this.averageNightShiftHours = projectData.data[0].average_night_shift_hours;
      [this.projectOverallData] = projectData.data; // Store data[0] in the member variable

      this.projectEmitCashFlow.emit({ projectEmitCashFlow: true });
    });
  }

  // TO GET COMPANY LOGO DATA FROM DB THROUGH COMPANY SERVICE
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // when tabs in graph are clicked, then this function call to change the graph and its color
  changeGraph(labelName, colorName) {
    const objData = this.chart.datasets.find((o) => {
      return o.label === labelName;
    });
    const objColor = this.chart.colors.find((o) => {
      return o.backgroundColor === `#${colorName}`;
    });
    if (objData) {
      const dataLength = this.chart.datasets.length;
      if (dataLength > 1) {
        this.chart.datasets.splice(this.chart.datasets.indexOf(objData), 1);
        this.chart.colors.splice(this.chart.colors.indexOf(objColor), 1);
        this.selectLabel.splice(this.selectLabel.indexOf(labelName), 1);
      }
    } else {
      if (labelName === 'GOI') {
        this.chart.datasets.push({
          data: this.GOIQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
        this.selectLabel.push(labelName);
      } else if (labelName === 'OE') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.OEQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'NOI') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.NOIQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'DS') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.DSQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'PL') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.PLQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'CI') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.CIQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'CD') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.CDQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'NCF') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.NCFQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'AOC') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.AOCQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      } else if (labelName === 'AM') {
        this.selectLabel.push(labelName);
        this.chart.datasets.push({
          data: this.AMQuaterlyArray,
          label: labelName,
          fill: false,
          lineTension: 0,
          borderWidth: 3,
        });
      }
      this.lineChartData = this.chart.datasets;

      this.chart.colors.push({
        backgroundColor: `#${colorName}`,
        borderColor: `#${colorName}`,
        pointBackgroundColor: `#${colorName}`,
        pointBorderColor: `#${colorName}`,
        pointHoverBackgroundColor: `#${colorName}`,
        pointHoverBorderColor: `#${colorName}`,
      });
      this.lineChartColors = this.chart.colors;
    }
    this.chart.chart.destroy();
    this.chart.chart = 0;
    this.chart.datasets = this.lineChartData;
    this.chart.colors = this.lineChartColors;
    this.chart.ngOnInit();
  }

  getProjectType() {
    const data = {
      project_id: this.projectId,
      projectId: this.projectId,
    };
    this.projectService.getProjectType(data).subscribe((projectTypeData) => {
      this.projectType = projectTypeData.data[0].business_type;
    });
  }

  // update value of cash flow' parameters to save them into db onchnage action
  updateValue(event, startUpMonth) {
    const fieldName = event.target.name;

    //
    // Get rid of any prefixes or suffixes from the text that is shown on the screen.
    //
    let value = CashflowComponent.replaceDollarsCommasPercentages(event.target.value);
    value = value === '' ? null : Number(value);
    let data = {};

    if (fieldName === 'vacancyFactor') {
      if (value === this.vacancyFactorInt) {
        return;
      }
      this.vacancyFactorInt = value;

      this.vacancyFactor = value;

      data = {
        fieldName: 'vacancyFactor',
        value,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        bed_rate: this.bedRate,
        bedRate: this.bedRate,
        project_id: this.projectId,
        projectId: this.projectId,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        start_up_month: startUpMonth,
        startUpMonth,
      };
    } else if (fieldName === 'foodCost') {
      if (value === this.foodCostInt) {
        return;
      }
      this.foodCost = value;
      data = {
        fieldName: 'foodCost',
        value,
        start_up_month: this.start_up_month,
        startUpMonth: this.start_up_month,
        avgWage: this.averageHourlyWageInt,
        inflationRate: this.inflationRate,
      };
      // Update the initial value for the food cost so we don't send it through again unless the value has changed.
      // TODO: The initial values should only be updated once the API call completes successfully. If the call fails, the UI should show an
      // error and display the original value again.
      this.foodCostInt = value;
    } else if (fieldName === 'averageHourlyWage') {
      if (value === this.averageHourlyWageInt) {
        return;
      }
      this.averageHourlyWageInt = value;

      this.averageHourlyWage = value;
      data = {
        fieldName: 'averageHourlyWage',
        value,
        vacancy_factor: this.vacancyFactor,
        vacancyFactor: this.vacancyFactor,
        project_id: this.projectId,
        projectId: this.projectId,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        bed_rate: this.bedRate,
        bedRate: this.bedRate,
        start_up_month: this.start_up_month,
        startUpMonth: this.start_up_month,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        average_night_shift_hours: this.averageNightShiftHours,
        averageNightShiftHours: this.averageNightShiftHours,
        avgWage: Number(this.averageHourlyWage),
        food_cost_initial: this.foodCostInt,
        foodCostInitial: this.foodCostInt,
      };
    } else if (fieldName === 'operatingCapital') {
      if (value === this.operatingCapitalInt) {
        return;
      }
      this.operatingCapitalInt = value;

      this.operatingCapital = value;
      data = {
        fieldName: 'operatingCapital',
        value,
      };
    } else if (fieldName === 'bedRate') {
      if (value === this.bedRateInt) {
        return;
      }
      this.bedRateInt = value;

      this.bedRate = value;
      data = {
        fieldName: 'bedRateOtherr',
        value,
        vacancy_factor: this.vacancyFactor,
        vacancyFactor: this.vacancyFactor,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        project_id: this.projectId,
        projectId: this.projectId,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        start_up_month: startUpMonth,
        startUpMonth,
        projectType: this.projectType,
      };
    }

    this.projectService.onChangeProject(this.projectId, data).subscribe(
      (/* res */) => {
        this.getCashFlow();
      },
      (/* err */) => {
        // this.toastr.error(err.message,'Error')
      }
    );
  }

  // TO REMOVE DOLLER AND COMMAS FROM VALUES
  static replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/cashflow/cashflow.component.ts